export default __webpack_public_path__ + "img/49.09dd87.png";